import type { HubAsset, ScenarioId, SinglePlayerDifficulty } from './types';
import type { ChallengeStartId } from './challengeStarts';

export interface ScenarioDefinition {
  id: ScenarioId;
  title: string;
  detail: string;
  headquartersId: string;
  startingCash: number;
  startingReputation: number;
  startingSpecialization: HubAsset['specialization'];
  objective: string;
}

export const SCENARIOS: Record<ScenarioId, ScenarioDefinition> = {
  sandbox: {
    id: 'sandbox', title: '自由沙盒', detail: '从香港起步，保留完整经济缓冲。', headquartersId: 'HKG', startingCash: 40_000_000, startingReputation: 52, startingSpecialization: 'balanced', objective: '建立第一条稳定盈利航线',
  },
  regional: {
    id: 'regional', title: '区域新兴航司', detail: '资金更紧，但适合用支线网络快速建立区域优势。', headquartersId: 'HKG', startingCash: 30_000_000, startingReputation: 50, startingSpecialization: 'connection', objective: '在 52 周内运营 10 条区域航线',
  },
  lowcost: {
    id: 'lowcost', title: '廉航挑战者', detail: '以低成本和高密度航线换取规模，现金缓冲较薄。', headquartersId: 'KUL', startingCash: 32_000_000, startingReputation: 48, startingSpecialization: 'lowcost', objective: '维持 90% 以上经济舱座位并连续盈利',
  },
  premium: {
    id: 'premium', title: '高端全服务旗舰', detail: '起点声誉更高，维护成本和服务要求也更高。', headquartersId: 'SIN', startingCash: 65_000_000, startingReputation: 68, startingSpecialization: 'premium', objective: '打造高端航线组合并保持声誉 92+',
  },
};

export interface NewGameOptions {
  scenarioId: ScenarioId;
  difficulty: SinglePlayerDifficulty;
  aiCount: 0 | 1 | 2 | 3 | 4 | 5;
  headquartersId?: string;
  challengeStartId?: ChallengeStartId;
  seed?: number;
}

export const DEFAULT_NEW_GAME_OPTIONS: NewGameOptions = {
  scenarioId: 'sandbox',
  difficulty: 'beginner',
  aiCount: 0,
};

export function scenarioFor(id: ScenarioId): ScenarioDefinition {
  return SCENARIOS[id] ?? SCENARIOS.sandbox;
}
